import { LazyChatThreadsList } from "@circle-react/components/Chat/ChatThreads/LazyChatThreadsList";

import { CHAT_THREADS_HEADER_ID } from "../../constants";

/**
 * Renders the chat threads list inside the mobile nav drawer.
 */
export const MobileChatThreadsDrawerContent = () => (
  <div id={CHAT_THREADS_HEADER_ID} className="h-full overflow-y-auto">
    <LazyChatThreadsList isRenderedOnHeader />
  </div>
);
